import thinkingdata from "thinkingdata-browser";
import RE from "../assets/replace.js";
import { gtagReportClick } from "./gg.js";

const config = {
    appId: "82a8931918ca4797813f51231bb288c5",
    serverUrl: "https://receiver.habby.mobi/sync_js",
    showLog: false,
};

function getUrlParam(key) {
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get(key) || "";
    } catch (e) {
        return "";
    }
}

const DISTINCT_ID_KEY = "piroker_tga_distinct_id";

function generateDistinctId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function getOrCreateDistinctId() {
    try {
        let id = window.localStorage.getItem(DISTINCT_ID_KEY);
        if (!id) {
            id = generateDistinctId();
            window.localStorage.setItem(DISTINCT_ID_KEY, id);
        }
        return id;
    } catch (e) {
        return generateDistinctId();
    }
}

function detectSandbox() {
    try {
        const host = (window.location.hostname || "").toLowerCase();
        const prodHosts = ["piroker.com", "www.piroker.com"];
        return !prodHosts.includes(host);
    } catch (e) {
        return true;
    }
}

const publicData = {
    game: RE.game,
    source: getUrlParam("source"),
    is_sandbox: detectSandbox(),
};

console.log("[TGA] module loaded");

try {
    thinkingdata.init(config);
    console.log("[TGA] init done");
    thinkingdata.identify(getOrCreateDistinctId());
    console.log("[TGA] identify done");
} catch (e) {
    console.warn("[TGA] init failed", e);
}

let hasReportedShow = false;

export const TGA = {
    login(uniqueId) {
        thinkingdata.login(uniqueId);
    },
    track(event, data) {
        const props = Object.assign({}, publicData, data || {});
        console.log("[TGA] track", event, props);
        try {
            thinkingdata.track(event, props);
        } catch (e) {
            console.warn("[TGA] track failed", e);
        }
    },
    trackShow() {
        console.log("[TGA] trackShow called");
        if (hasReportedShow) return;
        hasReportedShow = true;
        this.track("web_official_show");
    },
    trackClick(name) {
        console.log("[TGA] trackClick called", name);
        this.track("web_official_click", { name });
        gtagReportClick(name);
    },
};

if (typeof window !== "undefined") {
    window.__TGA__ = TGA;
}



// WEBPACK FOOTER //
// ./src/utils/tga.js